export default __webpack_public_path__ + "static/nwy-b4a8e881560848e4bea72207fa8ec852.jpeg";